import { TFunction } from 'i18next'

import {
  FormBlocker,
  FormBlockerElementLocalImageElementIcon,
  FormBlockerElementTextElementSize,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'

export const createErrorBlocker = (translation: TFunction): FormBlocker => ({
  elements: [
    { local_image_element: { icon: FormBlockerElementLocalImageElementIcon.FAILURE } },
    {
      text_element: {
        size: FormBlockerElementTextElementSize.LARGE,
        text: translation('Something went wrong', { context: 'header in an error message' }),
      },
    },
    {
      text_element: {
        size: FormBlockerElementTextElementSize.MEDIUM,
        text: translation('We’re working on it. Please try again.', { context: 'description inside an error message' }),
      },
    },
  ],
  primary_action: {
    text: translation('Retry', { context: 'button CTA to reload the page' }),
    internal_navigation_action: {
      client_route: {
        url: 'https://internal.cash.app/dl/view/reload',
      },
    },
  },
})
